var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentCallAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.469,
    height: 11.469,
    viewBox: "0 0 11.469 11.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.294 4.97A9.919 9.919 0 006.5 9.175l1.4-1.4a.507.507 0 01.637-.127 6.665 6.665 0 002.294.382.6.6 0 01.637.637v2.166a.6.6 0 01-.637.637A10.823 10.823 0 010 .637.6.6 0 01.637 0h2.23A.6.6 0 013.5.637a7.216 7.216 0 00.382 2.294.785.785 0 01-.127.637z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentCallAudio);
export default __webpack_public_path__ + "static/media/recent-call-audio.fbdc625b.svg";
export { ForwardRef as ReactComponent };